export const /** @type {?} */ FormTemplates = {
  defaultTemplate: {
    property: {
      display: true,
      disable: false,
      questions: [],
      maxColumns: 1,
      commonQuestions: [],
      key: '',
      submitButton: {
        display: true,
        disable: false,
        label: 'Submit'
      },
      payload: null
    },
    style: {}
  },
  healthCareTemplate: {
    headerQuestions: [
      {
        componentType: 'input',
        label: 'Subject Initials',
        type: 'text',
        value: '',
        required: true,
        key: 'initials'
      },
      {
        componentType: 'input',
        label: 'Subject ID',
        type: 'text',
        value: '',
        required: true,
        key: 'subjectId'
      }
    ],
    style: {}
  }
}
